import { Box, Paragraph, Text } from '@zillow/constellation-10';

export const CoFeesDisclaimer = () => (
  <Box css={{ marginTop: 'loose', marginBottom: 'loose' }}>
    <Paragraph textStyle="fineprint-bold" css={{ color: 'text.subtle' }}>
      Colorado fee protections
    </Paragraph>
    <Text textStyle="fineprint" css={{ color: 'text.subtle' }}>
      To cover the cost of processing a credit or charge card transaction, and pursuant to section 5-2-212, Colorado
      Revised Statutes, a seller or lessor may impose a processing surcharge in an amount not to exceed 2% of the total
      payment made for goods or services purchased or leased by use of a credit or charge card. A seller or lessor shall
      not impose a processing surcharge on payments made by use of cash, a check, or a debit card or redemption of a
      gift card.
    </Text>
  </Box>
);

export default CoFeesDisclaimer;
